import React, { Fragment, Component } from 'react';
import GridItem from "../Grid/GridItem.jsx"
import GridContainer from "../Grid/GridContainer.jsx";
import {  Formik, Form, Field } from 'formik';
import { baseUrl } from '../../components/shared/baseUrl';
import axios from "axios";
import {
  Grid,
  Container,
  InputAdornment,
  IconButton,
  Card,
  CardContent,
  Button,
  Tooltip,
  TextField
} from '@mui/material';

import MailOutlineTwoToneIcon from '@mui/icons-material/MailOutlineTwoTone';

class Footer extends Component {

  constructor() {
    super()
    this.state = {
      email: '',
      message:'',
      errors:''
    }

    this.validateEmail = this.validateEmail.bind(this);
  }



  validateEmail(value) {
    let error;
    //console.log(value.length);
    value = this.state.email
    if(value.length===0){
      error = 'Please enter email address'
     }
    else if(!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)){
      error = 'Invalid email address'
  }
    return error;
  }

  onChange = event => {
    console.log(event.target)
    this.setState({ email: event.target.value });
  }
  onChangeMessage = event => {
    this.setState({
      message:event.target.value
    })
  }

  render() {
    return (
      <Fragment>
        <div className="bg-first py-5">
          <div>
            <Container maxWidth="md" className="text-center">
              <h1 className="display-3 mb-4 text-white font-weight-bold">
                Stay up to date
              </h1>
              <p className="font-size-lg text-white-50">
                Follow us on any of our social media accounts to find out when
                we release new activities.
              </p>
            </Container>
            <div className="divider border-2 d-sm-none d-md-block rounded-circle border-white bg-white mx-auto mb-4 mt-5 w-50" />
            <div className="d-flex justify-content-center">
              <Tooltip arrow title="Facebook">
              <IconButton className="nav-link text-white-50">
                  <span className="btn-wrapper--icon">
                    <a className="btn btn-social-icon btn-facebook" href="http://www.facebook.com/profile.php?id=">
                      <i className="fa fa-facebook"></i>
                    </a>
                  </span>
                </IconButton>
              </Tooltip>
              <Tooltip arrow title="Twitter">
                <IconButton className="nav-link text-white-50">
                  <span className="btn-wrapper--icon">
                  <a className="btn btn-social-icon btn-twitter" href="http://twitter.com/"><i className="fa fa-twitter"></i></a>
                  </span>
                  </IconButton>
              </Tooltip>
              <Tooltip arrow title="Google+">
                <IconButton
                  className="nav-link text-white-50">
                  <span className="btn-wrapper--icon">
                  <a className="btn btn-social-icon btn-google" href="http://google.com/+"><i className="fa fa-google-plus"></i></a>
                  </span>
                </IconButton>
              </Tooltip>
              <Tooltip arrow title="Youtube">
                <IconButton
                  className="nav-link text-white-50">
                  <span className="btn-wrapper--icon">
                  <a className="btn btn-social-icon btn-google" href="http://youtube.com/"><i className="fa fa-youtube"></i></a>
                  </span>
                </IconButton>
              </Tooltip>
              <Tooltip arrow title="LinkedIn">
                <IconButton
                  className="nav-link text-white-50">
                  <span className="btn-wrapper--icon">
                  <a className="btn btn-social-icon btn-linkedin" href="http://www.linkedin.com/in/"><i className="fa fa-linkedin"></i></a>
                  </span>
                </IconButton>
              </Tooltip>
            </div>
            <div className="divider border-2 d-sm-none d-md-block rounded-circle border-white bg-white opacity-1 mx-auto my-4 w-50" />
            <Container maxWidth="xs" className="text-center">
              <Card className="mt-5 card-box">
                <CardContent className="p-3">
                  <div className="text-black">
                    <h1 className="display-4 mb-3 font-weight-bold">
                      Contact us
                    </h1>
                    <p className="font-size-md mb-4 text-black-50">
                      Enter you details here
                    </p>
                    <div id="mc_embed_signup">
                    
                    <Formik
                       initialValues={{
                        email:'',
                        message:''
                        }}
    
    
                        onSubmit={(values, {setSubmitting}) => {
                         setTimeout(() => {
                            setSubmitting(false);
                       
    
                        const data={
                          message:this.state.message,
                          email:this.state.email
                    
                        } 
                        console.log(data);
                        let url = `${baseUrl}sendemail`;
        
                        axios.post(url, data)
                        .then(response => {
                          if(response.data !== null){
                            this.setState({
                              errors:'',
                              status:response.data.status,
                        
                            });
                          }
                            console.log(response.data)
                        })
                        .catch(errors => 
                          this.setState({
                            errors:'Message not sent'
                          }),
                          console.log(this.state.errors));
    
                         }, 500);
                        }}
                    >

                  {({submitForm, isSubmitting, touched, errors}) => (
                  <Form>
                                
                                <Grid xs={12} item>
                                    <div id="mc_embed_signup_scroll">
                                      <div className="mc-field-group">
                                       
                                        <Field
                                          component={TextField}
                                          className="mt-0"
                                          margin="dense"
                                          //label="Email address"
                                          type="email"
                                          name="email"
                                          variant="outlined"
                                          placeholder="Email"
                                          onChange={this.onChange}
                                          value={this.state.email}
                                          //error={errors.email}
                                          fullWidth={true}
                                          InputProps={{
                                            startAdornment: (
                                              <InputAdornment position="start">
                                                <MailOutlineTwoToneIcon />
                                              </InputAdornment>
                                            )
                                          }}
                                          validate={this.validateEmail}
                                        />
                                      </div>
                                      
                                    </div>
                                  </Grid> 
                                <GridContainer>
                                  <GridItem xs={12} >
                                    <Field
                                      component={TextField}
                                      placeholder="Enter your message"
                                      type="text"
                                      name="message"
                                      onChange={this.onChangeMessage}
                                      value={this.state.message}
                                      fullWidth={true}
                                      variant="outlined"
                                      //validate={this.validateName}
                                      InputProps={{
                                        multiline: true,
                                        rows: 5
                                      }}
                                    />
                                  </GridItem>
                                </GridContainer>
                                <Grid container spacing={4}>
                                  
                                  <Grid xs={4} item>
                                    <Button
                                      className="w-100"
                                      color="primary"
                                      variant="contained"
                                      id="submit-contact"
                                      onClick={submitForm}                                     
                                      name="subscribe"
                                      type="submit"
                                      >
                                      <span className="btn-wrapper--label">Submit</span>
                                    </Button>
                                  </Grid> 
                                </Grid>
                                </Form>
                          )}
                    </Formik>                 
                    </div>
                    <small className="text-black-50 d-block pt-3">
                      We will contact you through mail.
                    </small>
                    
                  </div>
                </CardContent>
              </Card>
              <small className="text-white-50 d-block pt-3">             
                    <p>© Copyright {1900 + new Date().getYear()}{" "}CT-Onlinq</p>
            </small>
            </Container>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default Footer;
